import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardDaysStore } from '../../../../models/useDashboardDaysModel';
import { useUtcOffsetStore } from '../../../../models/useUtcOffsetModel';
import { DashboardPeriod } from '../../../../types/dashboard';
import { formatTableTopX } from '../../../../utils/table';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import { ScamData, ScamWidgetId } from './type';

type Props =
  | {
      type: ScamWidgetId.ScamTopEmailSender;
      data: Pick<ScamData, ScamWidgetId.ScamTopEmailSender>;
    }
  | {
      type: ScamWidgetId.ScamTopRecipient;
      data: Pick<ScamData, ScamWidgetId.ScamTopRecipient>;
    };

function ScamTop5Widget({ type, data }: Props) {
  const { t } = useTranslation();
  const { offset } = useUtcOffsetStore();
  const {
    days: { DashboardScam: day },
  } = useDashboardDaysStore();

  const config = [
    { width: '30%', grow: 1, align: 'left', tooltip: true },
    { width: '15%', grow: 0, align: 'right' },
    { width: '30%', grow: 1, align: 'left', tooltip: true },
    { width: '20%', grow: 0, align: 'left', tooltip: true },
  ];
  const header = [
    t('dashboard.chart.column.sender'),
    t('dashboard.chart.column.detections'),
    t('dashboard.chart.column.subject'),
    t('dashboard.chart.column.lastDetected'),
  ];

  const tableData = formatTableTopX(
    type === ScamWidgetId.ScamTopRecipient
      ? data.scamTopRecipient[day as DashboardPeriod]
      : data.scamTopEmailSender[day as DashboardPeriod],
    ['key', 'total', 'aliases', 'last_detected'],
    t,
    offset
  );

  return (
    <DashboardCard
      title={t(`dashboard.chart.title.${type}`)}
      iconContent={t(`dashboard.chart.desc.${type}`)}
    >
      <TableTemplate config={config} header={header} data={tableData} />
    </DashboardCard>
  );
}

export const ScamTop5 = React.memo(ScamTop5Widget);
